var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2013 14.9613C12.0024 14.9611 11.8118 14.882 11.6713 14.7413L8.20129 11.2613C8.06881 11.1191 7.99669 10.9311 8.00012 10.7368C8.00355 10.5424 8.08231 10.3571 8.21972 10.2197C8.35713 10.0822 8.54251 10.0035 8.73681 10.0001C8.93111 9.99669 9.11917 10.0688 9.26135 10.2013L12.2013 13.2013L15.1412 10.2013C15.2834 10.0688 15.4715 9.99669 15.6658 10.0001C15.8601 10.0035 16.0454 10.0822 16.1829 10.2197C16.3203 10.3571 16.399 10.5424 16.4025 10.7368C16.4059 10.9311 16.3338 11.1191 16.2013 11.2613L12.7313 14.7513C12.5892 14.8883 12.3987 14.9638 12.2013 14.9613Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.88db2fefa236dfdb1e81a799a679baff.svg";
export { ForwardRef as ReactComponent };